import { Epic, ofType } from "redux-observable";
import { of } from "rxjs";
import { exhaustMap } from "rxjs/operators";
import { RootState } from "../../reducers";
import { PreQuotationActions } from "../actions";
import { PreQuotationSubmit } from "../actions/default";
import { PRE_QUOTATION_SUBMIT } from "../constants";
import { LegalRepresentativePopupVerifyIfCustomerHasLegalRepresentative } from "../../legal-representative-popup/actions/default";
import { LoadingQuotation } from "../../quotation/actions/default";

export const preQuotationSubmitEpic: Epic<
    PreQuotationActions,
    PreQuotationActions,
    RootState
> = (action$) =>
    action$.pipe(
        ofType<PreQuotationActions, PreQuotationSubmit>(PRE_QUOTATION_SUBMIT),
        exhaustMap(() => {
            return of(
                new LoadingQuotation().create(),
                new LegalRepresentativePopupVerifyIfCustomerHasLegalRepresentative().create()
            );
        })
    );
